import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import {  useNavigate } from 'react-router';


export default function NotFound(){

    const navigate = useNavigate()

    const handleNavigate = ()=>{
        navigate('/dashboard');
    }

    return(
        <div className='zero-state-alerts zero-state-alerts-lg'>
        <Container fluid className='p-0'>                               
                <Row className='g-0'>
                    <Col>
                        <div className='icon-100 icon-nodata  mrgauto'></div>
                    </Col>                                    
                </Row>
                <Row className='g-0 mb-3'>
                    <Col className='d-flex flex-column justify-content-center align-items-center'>
                        <div className='font-medium font-size16 color-text line-height-1'>404</div>
                        <div className='font-medium font-size11 color-text mb-2'>Page Not Found!</div>
                        <div className='font-regular font-size5 color-subtext text-center'>We're sorry,the page you requested could not be found.<div className='break-line'>Please go back to the homepage!</div></div>
                    </Col>                                                                        
                </Row>
                <Row className='g-0 mb-3'>
                    <Col md={5}>&nbsp;</Col>
                    <Col md={2}><button type="button" className='btn btn-sm btn-primary btn-block' onClick={handleNavigate}>GO HOME</button></Col>      
                    <Col md={5}>&nbsp;</Col>                                                                             
                </Row>                               
        </Container>
        </div>
    )
}


